/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationInstance } from './NotificationInstance';
import {
    NotificationInstanceFromJSON,
    NotificationInstanceFromJSONTyped,
    NotificationInstanceToJSON,
} from './NotificationInstance';

/**
 * 
 * @export
 * @interface PaginatedNotificationInstanceList
 */
export interface PaginatedNotificationInstanceList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationInstanceList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationInstanceList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationInstanceList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<NotificationInstance>}
     * @memberof PaginatedNotificationInstanceList
     */
    results: Array<NotificationInstance>;
}

/**
 * Check if a given object implements the PaginatedNotificationInstanceList interface.
 */
export function instanceOfPaginatedNotificationInstanceList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function PaginatedNotificationInstanceListFromJSON(json: any): PaginatedNotificationInstanceList {
    return PaginatedNotificationInstanceListFromJSONTyped(json, false);
}

export function PaginatedNotificationInstanceListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedNotificationInstanceList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(NotificationInstanceFromJSON)),
    };
}

export function PaginatedNotificationInstanceListToJSON(value?: PaginatedNotificationInstanceList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(NotificationInstanceToJSON)),
    };
}

